<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-list :key="keyDocumentsSupplier">
      <v-list-item
        v-for="(item, index) in formDocumentsSupplier"
        :key="index"
        class="my-2"
      >
        <v-list-item-content>
          <v-list-item-title class="">
            {{ index + 1 }}. {{ item.name }}
          </v-list-item-title>
          <div class="mx-3">
            <a v-if="item.preview" @click="downloadFile(item)" href="#">
              <p class="font-italic mt-2 mb-2">
                <v-icon color="primary" small>
                  mdi-download
                </v-icon>
                {{ item.file.name }}
              </p>
            </a>
            <p
              v-else-if="item.file || item.id"
              class="mx-1 font-italic font-weight-bold mt-2 mb-1"
            >
              {{ item.file.name }}
            </p>
            <v-list-item-subtitle class="mt-2">
              <v-icon
                small
                :color="
                  item.file
                    ? 'success'
                    : item.key == 'general_conditions'
                    ? 'warning'
                    : 'red darken-4'
                "
              >
                {{
                  item.file
                    ? "mdi-check-circle"
                    : item.key == "general_conditions"
                    ? "mdi-information-outline"
                    : "mdi-alert-circle"
                }}
              </v-icon>
              <span
                :class="
                  `mt-2 ${
                    item.file
                      ? 'text-success'
                      : item.key == 'general_conditions'
                      ? 'text-warning'
                      : 'text-danger'
                  }`
                "
              >
                {{
                  item.file
                    ? "Documento cargado"
                    : item.key == "general_conditions"
                    ? "Documento opcional"
                    : "Documento pendiente"
                }}
              </span>
            </v-list-item-subtitle>
          </div>
        </v-list-item-content>
        <v-list-item-action v-if="!onlyShow">
          <section class="d-flex justify-space-between align-items-center mb-2">
            <v-tooltip top v-if="item.file == null && !item.id">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="uploadFile(item)" icon v-bind="attrs" v-on="on">
                  <v-icon color="primary">mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>Subir archivo</span>
            </v-tooltip>
            <v-tooltip top v-if="item.file !== null || item.id">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="uploadFile(item)"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="warning">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar Archivo</span>
            </v-tooltip>
            <v-tooltip top v-if="item.file !== null || item.id">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="deleteFile(item)"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar archivo</span>
            </v-tooltip>
          </section>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-file-input
      :key="keyFileInput"
      ref="fileInput"
      v-model="fileToUpload"
      type="file"
      id="uploadFile"
      accept="application/pdf"
      style="display: none"
    ></v-file-input>
  </section>
</template>

<script>
import { DOCUMENTS_LIST_FORM_STANDARD } from "@/constants/supplier";
import { authUsuarioComputed } from "@/state/helpers";
import { mapActions } from "vuex";
import { renameAndReturnNewFile } from "@/helpers/common";
export default {
  props: {
    onlyShow: {
      type: Boolean,
      default: false,
    },
    currentSupplier: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      keyDocumentsSupplier: 999,
      keyFileInput: 1999,
      loading: false,
      formDocumentsSupplier: DOCUMENTS_LIST_FORM_STANDARD.map((document) => ({
        ...document,
      })),
      fileToUpload: null,
      currentItem: null,
    };
  },
  methods: {
    ...mapActions({
      sendDeleteFileSupplier: "supplying/deleteFileSupplier",
      updateFilesSupplier: "supplying/updateFilesSupplier",
      deleteFileSupplier: "supplying/deleteFileSupplier",
    }),
    addFileToCreateSupplier(newFile) {
      // let newFilename = `${this.currentItem.name}.pdf`;
      if (this.currentItem) {
        this.$set(
          this.formDocumentsSupplier.find(
            (item) => item.key === this.currentItem.key
          ),
          "file",
          newFile
        );
      }
      // this.$set(
      //   this.formDocumentsSupplier.find(
      //     (item) => item.key === this.currentItem.key
      //   ),
      //   "new_filename",
      //   newFilename
      // );
    },
    async sendFileInUpdateSupplier(newFile, currentItem) {
      this.loading = true;
      let respDeleteDocument = null;
      if (currentItem.id) {
        let payloadDelete = {
          items: [
            {
              id: currentItem.id,
              user: this.user.email,
            },
          ],
          supplier_id: this.currentSupplier.id,
        };
        respDeleteDocument = await this.deleteFileSupplier(payloadDelete);
      }
      if (!this.currentItem.id || respDeleteDocument?.status == 200) {
        // let newFilename = `${currentItem.name}.pdf`;
        // let fileWithNewName = renameAndReturnNewFile(newFile, newFilename);
        let payloadUpdate = {
          id: this.currentSupplier.id,
          user: this.user.email,
          files: [newFile],
          doc_type: {
            [newFile.name]: currentItem.name,
          },
        };
        const respUpdateDocument = await this.updateFilesSupplier(
          payloadUpdate
        );
        if (respUpdateDocument?.status == 200) {
          this.$emit("fileUploaded");
          this.$swal.fire({
            icon: "success",
            title: "Excelente",
            text: "Archivo actualizado correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
      this.loading = false;
    },
    resetForm() {
      setTimeout(() => {
        this.formDocumentsSupplier = DOCUMENTS_LIST_FORM_STANDARD.map(
          (document) => ({ ...document })
        );
      }, 100);
      this.keyDocumentsSupplier = this.keyDocumentsSupplier + 1;
    },
    async uploadFile(item) {
      this.currentItem = item;
      document.getElementById("uploadFile").click();
    },
    async deleteFile(itemToDelete) {
      this.$swal
        .fire({
          icon: "error",
          title: `¿Estás seguro de eliminar el documento: <b>${itemToDelete.name}</b>?`,
          showCancelButton: true,
          showConfirmButton: true,
          //Color Rojo
          confirmButtonColor: "#F44336",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            if (itemToDelete.id) {
              this.loading = true;
              let payloadDelete = {
                items: [
                  {
                    id: itemToDelete.id,
                    user: this.user.email,
                  },
                ],
                supplier_id: this.currentSupplier?.id,
              };
              const resp = await this.sendDeleteFileSupplier(payloadDelete);
              if (!resp || !resp.status || resp.status == 500) {
                this.loading = false;
                return this.$swal({
                  icon: "error",
                  title: "Error",
                  text:
                    "Ha ocurrido un error en el servidor, intenta nuevamente",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
              if (resp && resp.status == 400) {
                this.loading = false;
                return this.$swal({
                  icon: "error",
                  title: "Error",
                  text: resp.data.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
              if (resp.status == 200) {
                this.$swal({
                  icon: "success",
                  title: "Excelente",
                  text: `Documento eliminado correctamente`,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
              this.$set(
                this.formDocumentsSupplier.find(
                  (item) => item.key === itemToDelete.key
                ),
                "id",
                null
              );
              this.$set(
                this.formDocumentsSupplier.find(
                  (item) => item.key === itemToDelete.key
                ),
                "file",
                null
              );
              this.$set(
                this.formDocumentsSupplier.find(
                  (item) => item.key === itemToDelete.key
                ),
                "preview",
                null
              );
              this.$emit("fileUploaded");
              this.loading = false;
            } else {
              this.$set(
                this.formDocumentsSupplier.find(
                  (item) => item.key === itemToDelete.key
                ),
                "file",
                null
              );
            }
          }
        });
    },
    getFiles() {
      return this.formDocumentsSupplier
        .filter((item) => item.file)
        .map((item) => {
          return item.file;
        });
    },
    getDocType() {
      let docType = {};
      this.formDocumentsSupplier.forEach((item) => {
        if (item.file) {
          docType[item.file.name] = item.name;
        }
      });
      return docType;
    },
    setDocumentsFromSupplier(supplier) {
      if (supplier) {
        supplier.documents.forEach((item) => {
          let indexDoc = this.formDocumentsSupplier.findIndex(
            (itemDoc) => itemDoc.name === item.document_type
          );
          if (indexDoc > -1) {
            this.formDocumentsSupplier[indexDoc].id = item.id;
            this.formDocumentsSupplier[indexDoc].preview = item.document_path;
            this.formDocumentsSupplier[indexDoc].file = {
              name: item.document_name,
            };
          }
        });
      }
    },
    async downloadFile(documentFile) {
      const response = await fetch(documentFile.preview.replace(/%/g, "%25"), {
        method: "GET",
      });
      const filename = `${documentFile.file.name}`;
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
  watch: {
    currentSupplier: {
      immediate: true,
      handler(currentSupplier) {
        if (currentSupplier) {
          this.setDocumentsFromSupplier(currentSupplier);
        }
      },
    },
    async fileToUpload(newFile) {
      if (newFile) {
        if (newFile.type !== "application/pdf") {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "El Documento debe tener formato .pdf",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        } else {
          if (!this.currentSupplier) {
            this.addFileToCreateSupplier(newFile);
          } else {
            await this.sendFileInUpdateSupplier(newFile, {
              ...this.currentItem,
            });
          }
        }
      }
      this.currentItem = null;
      this.fileToUpload = null;
      this.keyFileInput = this.keyFileInput + 1;
    },
  },
};
</script>

<style></style>
